import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";

class TelemetryService {
  constructor() {
    this.reactPlugin = new ReactPlugin();
  }

  initialize(reactPluginConfig,InstrumentationKey) {
      this.appInsights = new ApplicationInsights({
        config: {
          connectionString: InstrumentationKey,
          extensions: [this.reactPlugin],
          autoTrackPageVisitTime: true,          
          enableAutoRouteTracking: true,
          extensionConfig: {
            [this.reactPlugin.identifier]: reactPluginConfig
          }
        }
      });
      this.appInsights.loadAppInsights();
      this.appInsights.addTelemetryInitializer(envelope => {
        envelope.tags["ai.cloud.role"] = "UI";
      });
  }
}

export let ai = new TelemetryService();
